import {RemoteGetHealthDistrictsGuide} from 'data/usecases/private/guide-flow/medical-guide/remote-get-districts';
import {GetHealthDistrictsGuide} from 'domain/usecases/private/guide-flow/medical-guide/get-districts';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetDistrictsHealthGuide = (): GetHealthDistrictsGuide =>
	new RemoteGetHealthDistrictsGuide(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideDistricts),
		makeAuthorizeHttpClientDecorator(),
	);
